import { render } from "./News.vue?vue&type=template&id=66f16162&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=66f16162&scoped=true&lang=scss"

import exportComponent from "/Users/skynet/Documents/Sites Safe/Safe_Sites_Modifs/SAFE_MED/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f16162"]])

export default __exports__